import React from "react";
import styled from "styled-components";
//
import Facebook from "components/svg/fontawesome/FacebookSquare";
import Instagram from "components/svg/fontawesome/Instagram";
// import Twitter from 'components/svg/fontawesome/TwitterSquare';
// import Vimeo from 'components/svg/fontawesome/VimeoSquare';
//
export default ({ ...rest }) => (
  <Wrap {...rest}>
    <Item>
      <Link
        title="Find us on Instagram"
        href="https://www.instagram.com/riffrafffilms/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Instagram />
      </Link>
    </Item>
    <Item>
      <Link
        title="Find us on Facebook"
        href="https://www.facebook.com/RiffRaffFilms/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Facebook />
      </Link>
    </Item>
    {/* <Item>
      <Link
        title="Find us on Twitter"
        href="https://twitter.com/riffrafffilms"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Twitter />
      </Link>
    </Item> */}
    {/* <Item>
      <Link
        title="Find us on Vimeo"
        href="https://vimeo.com/riffrafffilms"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Vimeo />
      </Link>
    </Item> */}
  </Wrap>
);
//
const Wrap = styled.ul`
  border-top: 1px solid rgba(0, 0, 0, 0.5);
  display: flex;
  margin: 0 0 0.5rem;
  padding: 0.5rem 0 0;
`;
const Item = styled.li`
  padding-right: 0.5rem;
`;
const Link = styled.a`
  display: block;
  width: 1rem;

  svg {
    width: 100%;
  }
`;
